import dayjs from "dayjs";

export const sanitizeFileNamePart = (value, fallback = "All") => {
  const text = String(value ?? "")
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return text || fallback;
};

export const buildExportFileName = (reportName, detailParts = []) => {
  const report = sanitizeFileNamePart(reportName, "Report");
  const details = detailParts
    .filter((part) => part?.value !== undefined && part?.value !== null && part?.value !== "")
    .map((part) => `${sanitizeFileNamePart(part.label)}_${sanitizeFileNamePart(part.value)}`);

  return [report, ...details, dayjs().format("DD_MM_YYYY")].join("_") + ".xlsx";
};
